export default function Courage() {
  const principles = [
    {
      icon: 'ri-compass-3-line',
      title: 'Bold Decisions',
      description: 'We make courageous decisions that prioritize patient welfare and long-term impact over short-term gains.',
      stat: '100%',
      label: 'Patient-First'
    },
    {
      icon: 'ri-rocket-2-line',
      title: 'Risk-Taking',
      description: 'We embrace calculated risks in research and development to discover breakthrough treatments.',
      stat: '50+',
      label: 'New Projects'
    },
    {
      icon: 'ri-voice-recognition-line',
      title: 'Speaking Up',
      description: 'We encourage team members to voice concerns, challenge the status quo, and propose better solutions.',
      stat: '24/7',
      label: 'Open Door'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Ethical Courage',
      description: 'We stand firm on our ethical principles, even when faced with difficult choices or market pressures.',
      stat: 'Zero',
      label: 'Compromise'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
            COURAGE
          </div>
          <h2 className="text-5xl font-bold mb-6 leading-tight">
            The Courage to Make a Difference
          </h2>
          <p className="text-white/80 text-lg max-w-3xl mx-auto leading-relaxed">
            Courage drives us to push boundaries, challenge conventions, and pursue what's right rather than what's easy. We foster a culture where taking calculated risks, speaking truth to power, and standing up for our values is not just accepted—it's celebrated.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {principles.map((principle, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-all duration-300 border border-white/20"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-400 to-cyan-400 rounded-2xl">
                  <i className={`${principle.icon} text-white text-2xl`}></i>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-bold text-white">{principle.stat}</div>
                  <div className="text-white/70 text-sm">{principle.label}</div>
                </div>
              </div>
              <h3 className="text-2xl font-bold mb-4">{principle.title}</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                {principle.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 border border-white/20">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">Empowering Courageous Leadership</h3>
              <p className="text-white/80 text-lg mb-6 leading-relaxed">
                We believe that courage is not the absence of fear, but the determination to act despite it. Our leadership development programs focus on building resilience, fostering ethical decision-making, and empowering team members at all levels to lead with courage and conviction.
              </p>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-white/90">Leadership training and mentorship programs</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-white/90">Safe spaces for experimentation and learning</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-white/90">Recognition for courageous actions and decisions</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-white/90">Support systems for navigating challenges</span>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/assets/CultureCourage.jpg"
                  alt="Courageous Leadership"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
